// Auto-import SASS generated CSS
import './index.css';

export type {ModalProps} from './Modal';
export {default as default} from './Modal';
